import { render, staticRenderFns } from "./Settlements.vue?vue&type=template&id=736cc4f3&scoped=true"
import script from "./Settlements.vue?vue&type=script&lang=js"
export * from "./Settlements.vue?vue&type=script&lang=js"
import style0 from "./Settlements.vue?vue&type=style&index=0&id=736cc4f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736cc4f3",
  null
  
)

export default component.exports